import { useQuery } from "@tanstack/react-query";
import { fetchWeekAppointments } from "@/lib/services/appointmentService";
import type { Appointment } from "@/lib/types";
import { useAuth } from "@/features/auth/AuthContext";

/**
 * React Query hook for fetching week appointments.
 * @param weekStart - The week start date string (YYYY-MM-DD, Monday)
 */
export function useWeekAppointments(weekStart: string) {
  return useQuery<Record<string, Appointment[]>>({
    queryKey: ["weekAppointments", weekStart],
    queryFn: () => fetchWeekAppointments(weekStart),
    enabled: !!weekStart,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 60_000, // defensive liveness for passive viewers (doc 07 Phase B)
  });
}
